import Vue from "vue";
import Router from "vue-router";
import Hello from "@/components/HelloWorld";
import Home from "@/components/Home";
import Login from "@/components/login/Login";
import Adminman from "@/components/login/Adminman";
import LessonAdd from "@/components/LessonAdd";
import LessonEdit from "@/components/LessonEdit";
import LessonDetail from "@/components/teacher/ILessonDetail";


import LessonStudent from "@/components/teacher/LessonStudent";
import LessonDetailPublic from "@/components/LessonDetailPublic";
import LessonGrid from "@/components/LessonGrid";
import Dashboard from "@/components/Dashboard";
import TopicStat from "@/components/TopicStat";
import Questions from "@/components/Questions";
import QuestionAdd from "@/components/QuestionAdd";
import Asuulga from "@/components/Asuulga";
import QAPage from "@/components/QAPage";
import QuestionsAnswer from "@/components/QuestionsAnswer";
import LessonQuestionAdd from "@/components/LessonQuestionAdd";
import SubSchools from "@/components/SubSchools";
import Shalgaltuud from "@/components/Shalgaltuud";

import SchoolDetail from "@/components/SchoolDetail";
import DepartmentDetail from "@/components/DepartmentDetail";
import PublicQA from "@/components/PublicQA";
import Students from "@/components/Students";
import StudentAdd from "@/components/StudentAdd";

import Teachers from "@/components/Teachers";
import TeacherAdd from "@/components/TeacherAdd";
import LessonQA from "@/components/LessonQA";
import Register from "@/components/login/Register";
import AddInfo from "@/components/login/AddInfo";
import AllLessons from "@/components/AllLessons";
import DetailQuestions from "@/components/teacher/Questions";
import DetailQuestionAdd from "@/components/teacher/QuestionAdd";
import SimpleQuestionAdd from "@/components/teacher/SimpleQuestionAdd";
import ImageAdd from "@/components/ImageAdd";
import StudentDetail from "@/components/student/StudentDetail";
import Accounts from "@/components/admin/Accounts";
import AccountTransaction from "@/components/admin/AccountTransaction";
import TeacherDetail from "@/components/admin/TeacherDetail";
import LessonAttendance from "@/components/teacher/LessonAttendance";
import TeachersAdd from "@/components/admin/TeachersAdd";
import StudentsAdd from "@/components/admin/StudentsAdd";
import HomeLogin from "@/components/login/HomeLogin";
import TeacherLogin from "@/components/login/TeacherLogin";
import LessonDetailAdmin from "@/components/admin/LessonDetailAdmin";
import UserProfile from "@/components/login/UserProfile";
import TestResult from "@/components/student/TestResult";
import XChooseLessons from "@/components/student/XChooseLessons";

import News from "@/components/admin/News";
import Announcement from "@/components/admin/Announcement";
import Programs from "@/components/admin/Programs";
import ELibrary from "@/components/elibrary/ELibrary";
import ExamPage from "@/components/student/ExamPage";
import StudentProgramPlan from "@/components/student/StudentProgramPlan";
import ExamResult from "@/components/teacher/ExamResult";
import QuestionsScore from "@/components/teacher/QuestionsScore";


import Cities from "@/components/city/Cities";
import CityDetail from "@/components/city/CityDetail";
import DistrictDetail from "@/components/city/Schools";
import LessonTypes from "@/components/city/LessonTypes";

import PreStudents from "@/components/PreStudents";
import PreStudentAdd from "@/components/PreStudentAdd";
import PreStudentAddGradedu from "@/components/PreStudentAddGradedu";
import PreStudentDetail from "@/components/student/PreStudentDetail";

import RootLessonAdd from "@/components/rootlesson/RootLessonAdd";
import DepartmentLessons from "@/components/rootlesson/DepartmentLessons";
import ProgramYears from "@/components/rootlesson/ProgramYears";
import ProgramYearPlan from "@/components/rootlesson/ProgramYearPlan";
import RootLessonDetail from "@/components/rootlesson/RootLessonDetail";

import SLessons from "@/components/admin/SLessons";
import DLessons from "@/components/admin/DLessons";
import ILessonAdd from "@/components/admin/ILessonAdd";
import Admins from "@/components/admin/Admins";
import TeacherLessons from "@/components/admin/TeacherLessons";
import GlobalAlerts from "@/components/GlobalAlerts";

import LessonBook from "@/components/teacher/LessonBook";
import IContentDetail from "@/components/teacher/IContentDetail";
import SharedIContentDetail from "@/components/teacher/SharedIContentDetail";

import StudentContentDetail from "@/components/student/StudentContentDetail";

import ILessonLog from "@/components/teacher/ILessonLog";
import ILessonLogDetail from "@/components/teacher/ILessonLogDetail";
import ILessonScores from "@/components/teacher/ILessonScores";
import ILessonContentScores from "@/components/teacher/ILessonContentScores";
import FinanceStudents from "@/components/finance/FinanceStudents";

import firebase from "firebase";
import { store } from "../store.js";
import FileAdd from "@/components/FileAdd";

import XShalgalt from "@/components/teacher/shalgalt/XShalgalt"
import XShalgaltDetail from "@/components/teacher/shalgalt/XShalgaltDetail"

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/school/shalgaltuud/:xpath",
      name: "XShalgalt",
      component: XShalgalt,
      props: true,
      meta: {
        requiresAuth: true,
        // authorize: ["teacher", "sts", "admin", "superadmin"]
      }
    },
    {
      path: "/shalgalt/:shalgalt",
      name: "XShalgaltDetail",
      component: XShalgaltDetail,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["teacher", "sts", "admin", "student", "manager"]
      }
    },
    {
      path: '/shalgaltediting/:xpath',
      name: 'XShalgaltEditing',
      props: true,
      component: () => import("@/components/teacher/shalgalt/XShalgaltEditing"),
    },
    {
      path: '/shalgaltanswering/:item',
      name: 'XShalgaltAnswering',
      props: true,
      component: () => import("@/components/teacher/shalgalt/XShalgaltAnswering"),
    },
    {
      path: '/shalgaltsharing/:shalgaltIdd',
      name: 'XShalgaltSharing',
      props: true,
      component: () => import("@/components/teacher/shalgalt/XShalgaltSharing"),
    },
    {
      path: '/shalgaltresults/:item',
      name: 'XShalgaltResults',
      props: true,
      component: () => import('@/components/teacher/shalgalt/XShalgaltResults'),
    },
    // {
    // 	path: '/asuulgaanswering/:asuulgaId/:userId',
    // 	name: 'AsuulgaAnswering',
    // 	props: true, 
    // 	component: () => import("@/components/school/asuulga/AsuulgaAnswering"),
    // },


    {
      path: "/login",
      name: "Login",
      component: HomeLogin,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/studentlogin",
      name: "StudentLogin",
      component: Login,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/teacherlogin",
      name: "TeacherLogin",
      component: TeacherLogin,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/adminman",
      name: "Adminman",
      component: Adminman,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "*",
      redirect: "/dashboard"
    },
    {
      path: "/hello",
      name: "Hello",
      component: Hello,
      meta: {
        requiresAuth: true,
        authorize: ["teacher", "sts", "admin", "superadmin"]
      }
    },
    {
      path: "/home",
      name: "Home",
      component: Home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/lessonadd/:semesterId",
      name: "LessonAdd",
      component: LessonAdd,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["teacher", "sts", "admin", "superadmin"]
      }
    },
    {
      path: "/ilessonadd/:semesterId/:schoolId",
      name: "ILessonAdd",
      component: ILessonAdd,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["teacher", "sts", "admin", "manager", "superadmin"]
      }
    },
    {
      path: "/lessonedit/:lessonId",
      name: "LessonEdit",
      component: LessonEdit,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["teacher", "sts", "admin", "superadmin"]
      }
    },
    {
      component: LessonDetail,
      name: "LessonDetail",
      path: "/lesson/:lessonId",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["teacher", "sts", "admin", 'lesson_manager', "superadmin"]
      }
    },
    {
      component: LessonBook,
      name: "LessonBook",
      path: "/lesson/:parentPath/books",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["teacher", "sts", "admin", "superadmin"]
      }
    },
    {
      component: LessonStudent,
      name: "LessonStudent",
      path: "/lesson/:lessonId/students",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["teacher", "sts", "admin", "manager", "superadmin"]
      }
    },
    {
      component: LessonAttendance,
      name: "LessonAttendance",
      path: "/lesson/:lessonId/attendance",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["teacher", "sts", "admin", "manager", "superadmin"]
      }
    },
    {
      component: LessonGrid,
      name: "LessonGrid",
      path: "/lessons",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["student", "superadmin"]
      }
    },
    {
      component: LessonDetailPublic,
      name: "LessonDetailPublic",
      path: "/public/lesson/:lessonId",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["student"]
      }
    },
    {
      component: LessonDetailAdmin,
      name: "LessonDetailAdmin",
      path: "/admin/lesson/:lessonId",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "superadmin"]
      }
    },
    {
      component: Dashboard,
      name: "Dashboard",
      path: "/dashboard",
      meta: {
        requiresAuth: true
      }
    },
    {
      component: Asuulga,
      name: "Asuulga",
      path: "/qa",
      meta: {
        requiresAuth: true
      }
    },
    {
      component: QAPage,
      name: "QAPage",
      path: "/qapage",
      meta: {
        requiresAuth: true
      }
    },
    {
      component: Questions,
      name: "Questions",
      path: "/qa/:qaId/questions",
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      component: QuestionsAnswer,
      name: "QuestionsAnswer",
      path: "/qa/:qaId/answer",
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/qa/:qaId/questionadd/:questionId",
      name: "QuestionAdd",
      component: QuestionAdd,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/private/:path/:questionId",
      name: "LessonQuestionAdd",
      component: LessonQuestionAdd,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      component: SubSchools,
      name: "SubSchools",
      path: "/subschools",
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "lesson_manager", "superadmin"]
      }
    },
    {
      component: Shalgaltuud,
      name: "Shalgaltuud",
      path: "/shalgaltuud",
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "lesson_manager", "superadmin"]
      }
    },
    {
      path: "/subschools/:schoolId",
      name: "SchoolDetail",
      component: SchoolDetail,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "lesson_manager", "superadmin"]
      }
    },
    {
      path: "/subschools/:schoolId/department/:departmentId",
      name: "DepartmentDetail",
      component: DepartmentDetail,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "superadmin"]
      }
    },
    {
      path: "/subschools/:schoolId/department/:departmentId/lessons",
      name: "DepartmentLessons",
      component: DepartmentLessons,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "lesson_manager", "superadmin"]
      }
    },
    {
      path: "/subschools/:schoolId/department/:departmentId/lessonadd",
      name: "RootLessonAdd",
      component: RootLessonAdd,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "superadmin"]
      }
    },
    {
      path: "/subschools/:schoolId/department/:departmentId/programs/:programId",
      name: "ProgramYears",
      component: ProgramYears,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "superadmin"]
      }
    },
    {
      path: "/subschools/:schoolId/department/:departmentId/programs/:programId/plan",
      name: "ProgramYearPlan",
      component: ProgramYearPlan,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "superadmin"]
      }
    },
    {
      path: "/subschools/:schoolId/currentlessons",
      name: "SLessons",
      component: SLessons,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "lesson_manager", "superadmin"]
      }
    },
    {
      path: "/subschools/:schoolId/department/:departmentId/currentlessons",
      name: "DLessons",
      component: DLessons,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "lesson_manager", "superadmin"]
      }
    },
    {
      path: "/publicqa",
      name: "PublicQA",
      component: PublicQA,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/students",
      name: "Students",
      component: Students,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "superadmin"]
      }
    },
    {
      component: StudentDetail,
      name: "StudentDetail",
      path: "/student/:studentId",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "finance", "superadmin"]
      }
    },
    {
      path: "/studentadd/:studentId",
      name: "StudentAdd",
      component: StudentAdd,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "superadmin"]
      }
    },

    {
      path: "/teachers",
      name: "Teachers",
      component: Teachers,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "lesson_manager", "superadmin"]
      }
    },
    {
      component: TeacherDetail,
      name: "TeacherDetail",
      path: "/teachers/:studentId",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "lesson_manager", "superadmin"]
      }
    },
    {
      path: "/teacheradd/:teacherId",
      name: "TeacherAdd",
      component: TeacherAdd,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "superadmin"]
      }
    },
    {
      path: "/teachersadd",
      name: "TeachersAdd",
      component: TeachersAdd,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "superadmin"]
      }
    },
    {
      path: "/studentsadd",
      name: "StudentsAdd",
      component: StudentsAdd,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "superadmin"]
      }
    },
    {
      path: "/lessonqa/:lessonId",
      name: "LessonQA",
      component: LessonQA,
      props: true,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/addinfo",
      name: "AddInfo",
      component: AddInfo,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/alllessons",
      name: "AllLessons",
      component: AllLessons,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "superadmin"]
      }
    },
    {
      path: "/lesson/:lessonId/topic/:topicId/:detailId",
      name: "DetailQuestions",
      component: DetailQuestions,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/lesson/:lessonId/topic/:topicId/:detailId/score",
      name: "QuestionsScore",
      component: QuestionsScore,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/questionadd/:detailPath/:categoryId/:questionId",
      name: "DetailQuestionAdd",
      component: DetailQuestionAdd,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/simplequestionadd/:detailPath/:categoryId/:questionId",
      name: "SimpleQuestionAdd",
      component: SimpleQuestionAdd,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/imageadd/:objectPath",
      name: "ImageAdd",
      props: true,
      component: ImageAdd,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/userprofile",
      name: "UserProfile",
      component: UserProfile,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/stat/lesson/:lessonId/topic/:topicId/:contentId",
      name: "TestResult",
      component: TestResult,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/news",
      name: "News",
      component: News,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "superadmin"]
      }
    },
    {
      path: "/announcement",
      name: "Announcement",
      component: Announcement,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "superadmin"]
      }
    },
    {
      path: "/programs",
      name: "Programs",
      component: Programs,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "superadmin"]
      }
    },
    {
      path: "/elibrary",
      name: "ELibrary",
      component: ELibrary,
      meta: {
        requiresAuth: true,
        authorize: ["student", "teacher", "admin", "sts", "manager", "superadmin"]
      }
    },
    {
      path: "/chooselessons",
      name: "XChooseLessons",
      component: XChooseLessons,
      meta: {
        requiresAuth: true,
        authorize: ["student", "teacher", "admin", "sts", "manager", "superadmin"]
      }
    },
    {
      path: "/exam",
      name: "ExamPage",
      component: ExamPage,
      meta: {
        requiresAuth: true
      },
      props: true,
    },
    {
      path: "/exam/result",
      name: "ExamResult",
      component: ExamResult,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "superadmin", "teacher"]
      }
    },
    {
      path: "/lessontypes",
      name: "LessonTypes",
      component: LessonTypes,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "superadmin"]
      }
    },
    {
      path: "/cities",
      name: "Cities",
      component: Cities,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "superadmin"]
      }
    },
    {
      path: "/cities/:schoolId",
      name: "CityDetail",
      component: CityDetail,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "superadmin"]
      }
    },
    {
      path: "/cities/:schoolId/district/:departmentId",
      name: "DistrictDetail",
      component: DistrictDetail,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "superadmin"]
      }
    },
    {
      path: "/prestudents",
      name: "PreStudents",
      component: PreStudents,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "superadmin"]
      }
    },
    {
      path: "/prestudentadd/:studentId",
      name: "PreStudentAdd",
      component: PreStudentAdd,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "superadmin"]
      }
    },
    {
      path: "/prestudentaddgradedu/:studentId",
      name: "PreStudentAddGradedu",
      component: PreStudentAddGradedu,
      props: true,
      meta: {
        requiresAuth: false,
        // authorize: ["admin", "sts", "manager"]
      }
    },
    {
      component: PreStudentDetail,
      name: "PreStudentDetail",
      path: "/prestudent/:studentId",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "superadmin"]
      }
    },
    {
      path: "/subschools/:schoolId/rootlesson/:rootLessonId",
      name: "RootLessonDetail",
      component: RootLessonDetail,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "superadmin"]
      }
    },
    {
      path: "/admins",
      name: "Admins",
      component: Admins,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "superadmin"]
      }
    },
    {
      path: "/teacher/:teacherPath/currentlessons",
      name: "TeacherLessons",
      component: TeacherLessons,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "superadmin"]
      }
    },
    {
      path: "/globalqa",
      name: "GlobalAlerts",
      component: GlobalAlerts,
      props: true,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: "/student/programplan",
      name: "StudentProgramPlan",
      component: StudentProgramPlan,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/fileadd/:objectPath",
      name: "FileAdd",
      props: true,
      component: FileAdd,
      meta: {
        requiresAuth: true
      }
    },
    {
      component: IContentDetail,
      name: "IContentDetail",
      path: "/lesson/:lessonId/:topicId/:contentId",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["teacher", "sts", "admin", "lesson_manager", "superadmin"]
      }
    },
    {
      component: SharedIContentDetail,
      name: "SharedIContentDetail",
      path: "/sharinglesson/:lessonId/:topicId/:contentId",
      props: true,
    },
    {
      component: StudentContentDetail,
      name: "StudentContentDetail",
      path: "/public/lesson/:lessonId/:topicId/:contentId",
      props: true,
      meta: {
        requiresAuth: true,
      }
    },
    {
      component: ILessonLog,
      name: "ILessonLog",
      path: "/lesson/log/:lessonId",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["teacher", "sts", "admin", "superadmin"]
      }
    },
    {
      component: ILessonLogDetail,
      name: "ILessonLogDetail",
      path: "/lesson/logdetail/:lessonId/:logId",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["teacher", "sts", "admin", "superadmin"]
      }
    },
    {
      component: ILessonScores,
      name: "ILessonScores",
      path: "/lesson/scores/:lessonId",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["teacher", "sts", "admin", "superadmin"]
      }
    },
    {
      component: ILessonContentScores,
      name: "ILessonContentScores",
      path: "/lesson/:lessonId/content/scores",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["teacher", "sts", "admin", "superadmin"]
      }
    },
    {
      component: Accounts,
      name: "Accounts",
      path: "/accounts",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["finance", "superadmin"]
      }
    },
    {
      component: AccountTransaction,
      name: "AccountTransaction",
      path: "/accounts/:accountNumber",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["finance", "superadmin"]
      }
    },
    {
      component: FinanceStudents,
      name: "FinanceStudents",
      path: "/finance/list",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["finance", "superadmin"]
      }
    },
  ],
  linkActiveClass: "active", // active class for non-exact links.
  linkExactActiveClass: "active"
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth);
  const authorize = to.meta.authorize;
  const currentUser = firebase.auth().currentUser;

  // const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  // const currentUser = firebase.auth().currentUser

  if (store.getters.enabled == true) {
    // if (requiresAuth && !currentUser) {
    // 	next('/login')
    // } else if (requiresAuth && currentUser) {
    // 	next()
    // }
    // else if (requiresAuth==false) {
    // 	next()
    // }
    // else
    // 	next('/login')
    if (authorize != undefined) {
      if (requiresAuth && !currentUser) {
        next("/login");
      } else if (requiresAuth && currentUser) {
        if (
          authorize != null &&
          authorize.length > 0 &&
          store.getters.userProfile != null &&
          store.getters.userProfile.role != null &&
          authorize.includes(store.getters.userProfile.role)
        ) {
          next();
        } else {
          next("/");
        }
      } else if (requiresAuth == false) {
        next();
      } else next("/login");
    } else {
      if (requiresAuth && !currentUser) {
        next("/login");
      } else if (requiresAuth && currentUser) {
        next();
      } else if (requiresAuth == false) {
        next();
      } else next("/login");
    }
  } else {
    if (requiresAuth && !currentUser) {
      next("/login");
    } else if (requiresAuth && currentUser) {
      if (to.name != "AddInfo") {
        next("/addinfo");
      } else next();
    } else if (requiresAuth == false) {
      next();
    } else {
      next("/login");
    }
  }
});

export default router;
